<template>
  <w-modal
    v-model="value"
    :clickToClose="false"
    :escToClose="false"
    hideCloseButton
    variant="focus"
  >
    <template #header>
      <h1 class="sm:text-xl text-2xl text-center">
        繼續訂購？
      </h1>
    </template>
    <p class="sm:text-lg text-black text-xl">
      此為訪客連結，如需訂購請先登出。
    </p>
    <template #footer>
      <section class="flex items-center justify-end sm:justify-center">
        <w-button
          class="mr-2 sm:flex-grow"
          variant="text"
          @click="onCancel"
        >
          回到菜單列表
        </w-button>
        <w-button
          class="sm:flex-grow"
          @click="logoutAndContinue"
        >
          登出並繼續訂購
        </w-button>
      </section>
    </template>
  </w-modal>
</template>

<script>
import ContinueShareLink from './ContinueShareLink';

export default ContinueShareLink;
</script>

<style lang="scss" scoped>
@import 'ContinueShareLink';
</style>
